<template>
  <b-modal v-model="dialog.active" size="lg" centered hide-footer no-close-on-backdrop body-class="p-0"
           @hidden="reset">
    <template #modal-title>{{ editing ? msg('Edit') : msg("Add Guest Feature") }}</template>
    <b-card-body>
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="4" align-self="center">
              <b-img  :src="features.selected.imageUri" fluid thumbnail style="max-width: 240px; max-height: 300px"/>
            </b-col>
            <b-col cols="8">
              <b-row>
                <b-col cols="12">
                  <b-form-group :label="msg('Name')">
                    <v-select
                        :loading="features.loading"
                        :options="features.items"
                        v-model="features.selected"
                        label="name"
                        @search="searchFeatures"
                        @input="onFeatureSelected"
                    >
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group :label="msg('Description')">
                    <b-textarea v-model="features.selected.description" disabled placeholder="Description"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-form-group :label="msg('Image Uri')">
            <b-input v-model="features.selected.imageUri" disabled placeholder="Image Uri"/>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group :label="msg('Rate')">
            <b-input-group prepend="€" >
              <b-input number v-model="realEstateGuestFeature.rate" v-bind:disabled="!realEstateGuestFeature.featureId" />
            </b-input-group>
            <small class="text-muted">{{ msg('priceoverridehint') }}</small>
          </b-form-group>
        </b-col>
        <b-col cols="3" v-if="features.selected.amountAllowed">
          <b-form-group>
            <b-form-checkbox disabled  v-model="features.selected.amountAllowed">
              {{ msg('Amount Allowed') }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="3" v-if="features.selected.autoApprove">
          <b-form-group>
            <b-form-checkbox disabled v-model="features.selected.autoApprove">
              {{ msg('Auto Approve') }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="3" v-if="features.selected.dailyPayment">
          <b-form-group>
            <b-form-checkbox disabled v-model="features.selected.dailyPayment">
              {{ msg('Daily Payment') }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="3" v-if="features.selected.active">
          <b-form-group>
            <b-form-checkbox disabled v-model="features.selected.active">
              {{ msg('Active') }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <b-btn block @click="reset" variant="outline-primary" >{{ msg('Cancel') }}</b-btn>
        </b-col>
        <b-col cols="6">
          <b-btn block @click="saveFeature" variant="primary" v-bind:disabled="loading || !canSave">
            {{ editing ? msg('Update') : msg('Add') }}
          </b-btn>
        </b-col>
      </b-row>
    </b-card-body>
  </b-modal>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

const getRealEstateFeature = () => {
  return {
    featureId: null, rate: null
  }
}

export default {
  name: "GuestFeatureModalRealEstate",
  data: () => ({
    filter: {},
    page: {amount: 10, currentPage: 1, total: 0},
    dialog: {
      active: false,
    },
    loading: false,
    editing: false,
    features: {
      buids: null,
      loading: false,
      items: [],
      selected: {},
    },
    realEstateGuestFeature: getRealEstateFeature(),
  }),
  computed: {
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    canSave() {
      return this.realEstateGuestFeature.featureId != null &&
          this.realEstateGuestFeature.featureId.trim() !== "" &&
          this.realEstateGuestFeature.rate != null &&
          this.realEstateGuestFeature.rate !== "" &&
          !isNaN(this.realEstateGuestFeature.rate) &&
          parseFloat(this.realEstateGuestFeature.rate) > 0;
    }
  },
  methods: {
    ...mapActions('guestFeature',['fetchAllGuestFeature', 'insertGuestFeature', 'updateGuestFeature', 'fetchGuestFeatureById']),

    refresh() {

    },
    /**
     * @param text   name filter; empty loads the whole list
     * @param loading v-select's spinner callback — only present when the user types
     */
    loadFeatures(text, loading) {
      let $this = this;
      this.features.loading = true;
      if (loading) loading(true);
      // amount 100, not 10: this is the branch's own product list, and a short
      // page silently hid products staff had just created
      this.fetchAllGuestFeature({filter: {name: text || ''}, buids: this.features.buids, page: 1, amount: 100})
          .then(data => {
            $this.features.items = data.Features || [];
          })
          .catch(() => {
            $this.features.items = [];
          })
          .finally(() => {
            $this.features.loading = false;
            if (loading) loading(false);
          })
    },
    searchFeatures(text, loading) {
      this.loadFeatures(text, loading);
    },
    addNewFeature(buid) {
      this.reset();
      this.features.buids = [buid];
      this.dialog.active = true;
      // the dropdown used to stay empty until the user typed something —
      // @search is the ONLY thing that filled it
      this.loadFeatures('');
    },
    /**
     * Reopen on an existing row so its price can be changed.
     * @param row     the stored {featureId, rate} on the property/building
     * @param catalog the product itself, for the name/image/description
     */
    editFeature(buid, row, catalog) {
      this.reset();
      this.features.buids = [buid];
      this.features.selected = catalog ? {...catalog} : {};
      this.realEstateGuestFeature = {
        ...getRealEstateFeature(),
        ...(row || {}),
        // an empty override means "use the product default" — show that default
        // rather than an empty box, so saving cannot blank the price by accident
        rate: (row && row.rate != null && row.rate !== '') ? row.rate : (catalog ? catalog.defaultRate : null),
      };
      this.editing = true;
      this.dialog.active = true;
      this.loadFeatures('');
    },
    closeModal() {
      this.dialog.active = false;
      this.reset();
    },
    onFeatureSelected() {
      if(this.features.selected == null || this.features.selected.id == null){
        this.realEstateGuestFeature.featureId = null;
      }else {
        this.realEstateGuestFeature.featureId = this.features.selected.id;
      }
    },
    reset() {
      this.features.selected = {};
      this.realEstateGuestFeature = getRealEstateFeature();
      this.editing = false;
    },
    saveFeature() {
      this.$emit('save', this.realEstateGuestFeature);
    }
  }
}
</script>


<style scoped>

</style>
